import { FieldType } from "../../../components/ui/DynamicInput";

export const GROUP_DETAILS: { fields: FieldType[] } = {
    fields: [
        {
            name: "groupName",
            label: "Group Name",
            type: "text",
            validationRules: { required: "Group Name is required" },
        },
        {
            name: "groupCity",
            label: "City",
            type: "text",
            validationRules: { required: "City is required" },
        },
    ],
};
